import { render, staticRenderFns } from "./shop.vue?vue&type=template&id=3cb8df44"
import script from "./shop.vue?vue&type=script&lang=ts"
export * from "./shop.vue?vue&type=script&lang=ts"
import style0 from "./shop.vue?vue&type=style&index=0&id=3cb8df44&prod&lang=sass"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports